import React from "react";
import {
  ArrowUpRight,
  Megaphone,
  Filter,
  Users,
  Target,
  BarChart3,
  Handshake,
} from "lucide-react";
import { successStory, services } from "../data/mock";
import { Reveal } from "./ui/Reveal";

const serviceStyles = [
  { icon: Megaphone, bg: "bg-blue-50", text: "text-blue-600" },
  { icon: Filter, bg: "bg-violet-50", text: "text-violet-600" },
  { icon: Users, bg: "bg-emerald-50", text: "text-emerald-600" },
  { icon: Target, bg: "bg-amber-50", text: "text-amber-600" },
  { icon: BarChart3, bg: "bg-cyan-50", text: "text-cyan-600" },
  { icon: Handshake, bg: "bg-rose-50", text: "text-rose-600" },
];

const Feature = () => {
  return (
    <section className="py-24">
      <div className="max-w-[1280px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-14 items-center">
        <Reveal>
          <div className="rounded-3xl overflow-hidden bg-neutral-100 border border-black/5">
            <img src={successStory.image} alt="Growth dashboard" className="w-full h-full object-contain" />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <span className="inline-block text-[11px] tracking-[0.18em] uppercase text-neutral-500 border border-black/10 rounded-full px-3 py-1.5">{successStory.tag}</span>
          <h2 className="mt-5 text-[32px] sm:text-[44px] leading-[1.05] tracking-[-0.02em] font-semibold text-neutral-950">{successStory.title}</h2>
          <p className="mt-4 text-neutral-600">{successStory.desc}</p>
          <div className="relative inline-flex group mt-8">
            <div className="absolute -inset-1 rounded-xl opacity-60 blur-lg bg-gradient-to-r from-cyan-400 via-blue-500 to-fuchsia-500 transition-opacity duration-300 group-hover:opacity-90" />
            <a
              href={successStory.href}
              className="relative z-10 flex items-center gap-2 bg-black text-white pl-5 pr-4 py-3 rounded-xl text-[15px] font-medium transition-transform duration-200 group-hover:-translate-y-0.5"
            >
              {successStory.ctaLabel}
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export const Benefits = () => {
  return (
    <section className="bg-neutral-50 py-24">
      <div className="max-w-[1280px] mx-auto px-6">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-block text-[11px] tracking-[0.18em] uppercase text-neutral-500 border border-black/10 rounded-full px-3 py-1.5 bg-white">What I do</span>
            <h2 className="mt-5 text-[34px] sm:text-[48px] leading-[1.05] tracking-[-0.02em] font-semibold text-neutral-950">Built for businesses that want sustainable growth</h2>
            <p className="mt-4 text-[17px] text-neutral-600 leading-relaxed">End-to-end performance and growth solutions designed to help businesses, startups, and agencies scale revenue with clarity, control, and accountability.</p>
          </div>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service, i) => {
            const style = serviceStyles[i] || serviceStyles[0];
            const Icon = style.icon;
            return (
              <Reveal key={service.title} delay={(i % 3) * 0.1}>
                <div className="bg-white rounded-3xl p-8 border border-black/5 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 h-full">
                  <span className={`w-12 h-12 rounded-xl ${style.bg} flex items-center justify-center`}>
                    <Icon className={`w-6 h-6 ${style.text}`} />
                  </span>
                  <h3 className="mt-5 text-xl font-semibold text-neutral-950">{service.title}</h3>
                  <p className="mt-2.5 text-[15px] text-neutral-600 leading-relaxed">{service.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Feature;
